import { observer } from 'mobx-react';
import PrivateDistributionListMember from 'owa-persona/lib/models/PrivateDistributionListMember';
import MultiPersonaControl from 'owa-persona/lib/components/MultiPersonaControl/MultiPersonaControl';
import * as React from 'react';

const searchBoxPillWellStyles = require('./SearchBoxPillWell.scss');

export interface PrivateDistributionListPillProps {
    personas: PrivateDistributionListMember[];
    isSelected: boolean;
    name: string;
}

@observer
export default class PrivateDistributionListPill extends React.Component<
    PrivateDistributionListPillProps,
    {}
> {
    private pillDiv?: HTMLElement;

    componentDidUpdate?(prevProps: PrivateDistributionListPillProps, prevState: {}) {
        if (this.props.isSelected) {
            this.pillDiv.focus();
        }
    }

    render(): any {
        return (
            <div
                className={searchBoxPillWellStyles.personaPill}
                ref={ref => (this.pillDiv = ref)}
                tabIndex={-1}>
                <MultiPersonaControl personas={this.props.personas} isSearchPill={true} />
                <div className={searchBoxPillWellStyles.personaPillNameText}>{this.props.name}</div>
            </div>
        );
    }
}
